import { useState } from "react";
import styled from "styled-components";
import useFile from "../../hooks/useFile";
import FileSum from "../../components/blocks/fileSum";
import PageContainer from "../../components/containers/PageContainer";
import SearchBar from "../../components/search/searchBar";
import Loader from "../../components/interaction/Loader";
import PageNavigator from "../../components/nav/PageNavigator";
import useAuth from "../../hooks/useAuth";

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 20px;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const SearchContainer = styled.div`
  width: 600px;
`;

const TabsContainer = styled.div`
  display: flex;
  padding: 22px 30px;
  justify-content: center;
  align-items: center;
  gap: 50px;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid var(--Main-stroke-1, #ebebeb);
  background: #fcfcfc;
  max-width: 300px;
  margin: 0 auto;
`;

const Tab = styled.button<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? "#FF734F" : "#232129")};
  text-align: center;
  font-family: "Sharp Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  transition: color 0.2s ease;

  &:hover {
    color: #ff734f;
  }
`;

type LawTypeOption = "Tout" | "PJL" | "PPL";

const Files = () => {
  const [pageSelected, setPageSelected] = useState(1);
  const [selectedTab, setSelectedTab] = useState<LawTypeOption>("Tout");
  const { user } = useAuth();
  const getLawTypeParam = (tab: LawTypeOption): string | undefined => {
    switch (tab) {
      case "PJL":
        return "PJL";
      case "PPL":
        return "PPL";
      default:
        return undefined;
    }
  };

  const handleTabChange = (tab: LawTypeOption) => {
    setSelectedTab(tab);
    setPageSelected(1); // Reset to first page when changing tabs
  };

  const { data, loading, error } = useFile(
    pageSelected,
    getLawTypeParam(selectedTab),
    user?.user_id
  );
  console.log("Hook data:", data);

  if (loading) {
    return (
      <PageContainer>
        <Loader page={true} />
      </PageContainer>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!data || !data.Files) {
    return <p>No data</p>;
  }

  const tabs: LawTypeOption[] = ["Tout", "PJL", "PPL"];

  return (
    <PageContainer>
      <SearchContainer>
        <SearchBar />
      </SearchContainer>
      <TabsContainer>
        {tabs.map((tab) => (
          <Tab
            key={tab}
            isActive={selectedTab === tab}
            onClick={() => handleTabChange(tab)}
          >
            {tab}
          </Tab>
        ))}
      </TabsContainer>
      <Container>
        {data.Files.map((file) => (
          <FileSum
            uid={file.uid}
            name={file.name}
            wording={file.wording}
            status={file.status}
            stageFile={file.stage_file_title}
            stateFile={file.state_file_title}
            code={file.state_file_code}
            live={true}
          />
        ))}
      </Container>
      <PageNavigator
        pageSelected={pageSelected}
        pageList={Array.from({ length: data.total_pages }, (_, i) => i + 1)}
        setPageSelected={setPageSelected}
      />
    </PageContainer>
  );
};

export default Files;
